/**
 * Key prefix for a translation output file saved as a context-less workspace
 * artifact (kind `file`). Suffixed with the source asset id, so re-saving the
 * same generated file is idempotent. Shared between the API (mint) and the web
 * Library preview (routing).
 */
export const SAVED_FILE_ARTIFACT_KEY_PREFIX = 'saved-file:';
/**
 * A comprehensive list of language-country locales.
 */
export const SUPPORTED_LANGUAGES = [
    {
        languageCode: 'uz',
        countryCode: 'AF',
        language: 'Uzbek',
        country: 'Afghanistan',
    },
    {
        languageCode: 'sq',
        countryCode: 'AL',
        language: 'Albanian',
        country: 'Albania',
    },
    {
        languageCode: 'ar',
        countryCode: 'DZ',
        language: 'Arabic',
        country: 'Algeria',
    },
    {
        languageCode: 'ca',
        countryCode: 'AD',
        language: 'Catalan',
        country: 'Andorra',
    },
    {
        languageCode: 'pt',
        countryCode: 'AO',
        language: 'Portuguese',
        country: 'Angola',
    },
    {
        languageCode: 'es',
        countryCode: 'AR',
        language: 'Spanish',
        country: 'Argentina',
    },
    {
        languageCode: 'hy',
        countryCode: 'AM',
        language: 'Armenian',
        country: 'Armenia',
    },
    {
        languageCode: 'en',
        countryCode: 'AU',
        language: 'English',
        country: 'Australia',
    },
    {
        languageCode: 'de',
        countryCode: 'AT',
        language: 'German',
        country: 'Austria',
    },
    {
        languageCode: 'ar',
        countryCode: 'BH',
        language: 'Arabic',
        country: 'Bahrain',
    },
    {
        languageCode: 'bn',
        countryCode: 'BD',
        language: 'Bangla',
        country: 'Bangladesh',
    },
    {
        languageCode: 'be',
        countryCode: 'BY',
        language: 'Belarusian',
        country: 'Belarus',
    },
    {
        languageCode: 'nl',
        countryCode: 'BE',
        language: 'Dutch',
        country: 'Belgium',
    },
    {
        languageCode: 'fr',
        countryCode: 'BE',
        language: 'French',
        country: 'Belgium',
    },
    {
        languageCode: 'de',
        countryCode: 'BE',
        language: 'German',
        country: 'Belgium',
    },
    {
        languageCode: 'es',
        countryCode: 'BO',
        language: 'Spanish',
        country: 'Bolivia',
    },
    {
        languageCode: 'hr',
        countryCode: 'BA',
        language: 'Croatian',
        country: 'Bosnia & Herzegovina',
    },
    {
        languageCode: 'tn',
        countryCode: 'BW',
        language: 'Tswana',
        country: 'Botswana',
    },
    {
        languageCode: 'pt',
        countryCode: 'BR',
        language: 'Portuguese',
        country: 'Brazil',
    },
    {
        languageCode: 'bg',
        countryCode: 'BG',
        language: 'Bulgarian',
        country: 'Bulgaria',
    },
    {
        languageCode: 'fr',
        countryCode: 'CM',
        language: 'French',
        country: 'Cameroon',
    },
    {
        languageCode: 'en',
        countryCode: 'CA',
        language: 'English',
        country: 'Canada',
    },
    {
        languageCode: 'fr',
        countryCode: 'CA',
        language: 'French',
        country: 'Canada',
    },
    {
        languageCode: 'ar',
        countryCode: 'TD',
        language: 'Arabic',
        country: 'Chad',
    },
    {
        languageCode: 'es',
        countryCode: 'CL',
        language: 'Spanish',
        country: 'Chile',
    },
    {
        languageCode: 'zh',
        countryCode: 'CN',
        language: 'Chinese',
        country: 'China mainland',
    },
    {
        languageCode: 'en',
        countryCode: 'CN',
        language: 'English',
        country: 'China mainland',
    },
    {
        languageCode: 'ug',
        countryCode: 'CN',
        language: 'Uyghur',
        country: 'China mainland',
    },
    {
        languageCode: 'es',
        countryCode: 'CO',
        language: 'Spanish',
        country: 'Colombia',
    },
    {
        languageCode: 'fr',
        countryCode: 'CG',
        language: 'French',
        country: 'Congo - Brazzaville',
    },
    {
        languageCode: 'ln',
        countryCode: 'CG',
        language: 'Lingala',
        country: 'Congo - Brazzaville',
    },
    {
        languageCode: 'es',
        countryCode: 'CR',
        language: 'Spanish',
        country: 'Costa Rica',
    },
    {
        languageCode: 'hr',
        countryCode: 'HR',
        language: 'Croatian',
        country: 'Croatia',
    },
    {
        languageCode: 'es',
        countryCode: 'CU',
        language: 'Spanish',
        country: 'Cuba',
    },
    {
        languageCode: 'el',
        countryCode: 'CY',
        language: 'Greek',
        country: 'Cyprus',
    },
    {
        languageCode: 'cs',
        countryCode: 'CZ',
        language: 'Czech',
        country: 'Czechia',
    },
    {
        languageCode: 'da',
        countryCode: 'DK',
        language: 'Danish',
        country: 'Denmark',
    },
    {
        languageCode: 'es',
        countryCode: 'DO',
        language: 'Spanish',
        country: 'Dominican Republic',
    },
    {
        languageCode: 'es',
        countryCode: 'EC',
        language: 'Spanish',
        country: 'Ecuador',
    },
    {
        languageCode: 'ar',
        countryCode: 'EG',
        language: 'Arabic',
        country: 'Egypt',
    },
    {
        languageCode: 'es',
        countryCode: 'SV',
        language: 'Spanish',
        country: 'El Salvador',
    },
    {
        languageCode: 'et',
        countryCode: 'EE',
        language: 'Estonian',
        country: 'Estonia',
    },
    {
        languageCode: 'am',
        countryCode: 'ET',
        language: 'Amharic',
        country: 'Ethiopia',
    },
    {
        languageCode: 'fo',
        countryCode: 'FO',
        language: 'Faroese',
        country: 'Faroe Islands',
    },
    {
        languageCode: 'fi',
        countryCode: 'FI',
        language: 'Finnish',
        country: 'Finland',
    },
    {
        languageCode: 'sv',
        countryCode: 'FI',
        language: 'Swedish',
        country: 'Finland',
    },
    {
        languageCode: 'br',
        countryCode: 'FR',
        language: 'Breton',
        country: 'France',
    },
    {
        languageCode: 'co',
        countryCode: 'FR',
        language: 'Corsican',
        country: 'France',
    },
    {
        languageCode: 'fr',
        countryCode: 'FR',
        language: 'French',
        country: 'France',
    },
    {
        languageCode: 'oc',
        countryCode: 'FR',
        language: 'Occitan',
        country: 'France',
    },
    {
        languageCode: 'ka',
        countryCode: 'GE',
        language: 'Georgian',
        country: 'Georgia',
    },
    {
        languageCode: 'de',
        countryCode: 'DE',
        language: 'German',
        country: 'Germany',
    },
    {
        languageCode: 'ee',
        countryCode: 'GH',
        language: 'Ewe',
        country: 'Ghana',
    },
    {
        languageCode: 'el',
        countryCode: 'GR',
        language: 'Greek',
        country: 'Greece',
    },
    {
        languageCode: 'kl',
        countryCode: 'GL',
        language: 'Kalaallisut',
        country: 'Greenland',
    },
    {
        languageCode: 'es',
        countryCode: 'GT',
        language: 'Spanish',
        country: 'Guatemala',
    },
    {
        languageCode: 'es',
        countryCode: 'HN',
        language: 'Spanish',
        country: 'Honduras',
    },
    {
        languageCode: 'zh',
        countryCode: 'HK',
        language: 'Chinese',
        country: 'Hong Kong',
    },
    {
        languageCode: 'hu',
        countryCode: 'HU',
        language: 'Hungarian',
        country: 'Hungary',
    },
    {
        languageCode: 'is',
        countryCode: 'IS',
        language: 'Icelandic',
        country: 'Iceland',
    },
    {
        languageCode: 'as',
        countryCode: 'IN',
        language: 'Assamese',
        country: 'India',
    },
    {
        languageCode: 'bn',
        countryCode: 'IN',
        language: 'Bangla',
        country: 'India',
    },
    {
        languageCode: 'en',
        countryCode: 'IN',
        language: 'English',
        country: 'India',
    },
    {
        languageCode: 'gu',
        countryCode: 'IN',
        language: 'Gujarati',
        country: 'India',
    },
    {
        languageCode: 'hi',
        countryCode: 'IN',
        language: 'Hindi',
        country: 'India',
    },
    {
        languageCode: 'kn',
        countryCode: 'IN',
        language: 'Kannada',
        country: 'India',
    },
    {
        languageCode: 'kok',
        countryCode: 'IN',
        language: 'Konkani',
        country: 'India',
    },
    {
        languageCode: 'ml',
        countryCode: 'IN',
        language: 'Malayalam',
        country: 'India',
    },
    {
        languageCode: 'mr',
        countryCode: 'IN',
        language: 'Marathi',
        country: 'India',
    },
    {
        languageCode: 'or',
        countryCode: 'IN',
        language: 'Oriya',
        country: 'India',
    },
    {
        languageCode: 'pa',
        countryCode: 'IN',
        language: 'Punjabi',
        country: 'India',
    },
    {
        languageCode: 'sa',
        countryCode: 'IN',
        language: 'Sanskrit',
        country: 'India',
    },
    {
        languageCode: 'ta',
        countryCode: 'IN',
        language: 'Tamil',
        country: 'India',
    },
    {
        languageCode: 'te',
        countryCode: 'IN',
        language: 'Telugu',
        country: 'India',
    },
    {
        languageCode: 'ur',
        countryCode: 'IN',
        language: 'Urdu',
        country: 'India',
    },
    {
        languageCode: 'id',
        countryCode: 'ID',
        language: 'Indonesian',
        country: 'Indonesia',
    },
    {
        languageCode: 'jv',
        countryCode: 'ID',
        language: 'Javanese',
        country: 'Indonesia',
    },
    {
        languageCode: 'fa',
        countryCode: 'IR',
        language: 'Persian',
        country: 'Iran',
    },
    {
        languageCode: 'ar',
        countryCode: 'IQ',
        language: 'Arabic',
        country: 'Iraq',
    },
    {
        languageCode: 'en',
        countryCode: 'IE',
        language: 'English',
        country: 'Ireland',
    },
    {
        languageCode: 'ga',
        countryCode: 'IE',
        language: 'Irish',
        country: 'Ireland',
    },
    {
        languageCode: 'he',
        countryCode: 'IL',
        language: 'Hebrew',
        country: 'Israel',
    },
    {
        languageCode: 'it',
        countryCode: 'IT',
        language: 'Italian',
        country: 'Italy',
    },
    {
        languageCode: 'sc',
        countryCode: 'IT',
        language: 'Sardinian',
        country: 'Italy',
    },
    {
        languageCode: 'ja',
        countryCode: 'JP',
        language: 'Japanese',
        country: 'Japan',
    },
    {
        languageCode: 'ar',
        countryCode: 'JO',
        language: 'Arabic',
        country: 'Jordan',
    },
    {
        languageCode: 'kk',
        countryCode: 'KZ',
        language: 'Kazakh',
        country: 'Kazakhstan',
    },
    {
        languageCode: 'sw',
        countryCode: 'KE',
        language: 'Swahili',
        country: 'Kenya',
    },
    {
        languageCode: 'ar',
        countryCode: 'KW',
        language: 'Arabic',
        country: 'Kuwait',
    },
    {
        languageCode: 'es',
        countryCode: '419',
        language: 'Spanish',
        country: 'Latin America',
    },
    {
        languageCode: 'lv',
        countryCode: 'LV',
        language: 'Latvian',
        country: 'Latvia',
    },
    {
        languageCode: 'ar',
        countryCode: 'LB',
        language: 'Arabic',
        country: 'Lebanon',
    },
    {
        languageCode: 'ar',
        countryCode: 'LY',
        language: 'Arabic',
        country: 'Libya',
    },
    {
        languageCode: 'lt',
        countryCode: 'LT',
        language: 'Lithuanian',
        country: 'Lithuania',
    },
    {
        languageCode: 'fr',
        countryCode: 'LU',
        language: 'French',
        country: 'Luxembourg',
    },
    {
        languageCode: 'de',
        countryCode: 'LU',
        language: 'German',
        country: 'Luxembourg',
    },
    {
        languageCode: 'lb',
        countryCode: 'LU',
        language: 'Luxembourgish',
        country: 'Luxembourg',
    },
    {
        languageCode: 'mg',
        countryCode: 'MG',
        language: 'Malagasy',
        country: 'Madagascar',
    },
    {
        languageCode: 'ny',
        countryCode: 'MW',
        language: 'Nyanja',
        country: 'Malawi',
    },
    {
        languageCode: 'ms',
        countryCode: 'MY',
        language: 'Malay',
        country: 'Malaysia',
    },
    {
        languageCode: 'mt',
        countryCode: 'MT',
        language: 'Maltese',
        country: 'Malta',
    },
    {
        languageCode: 'ar',
        countryCode: 'MR',
        language: 'Arabic',
        country: 'Mauritania',
    },
    {
        languageCode: 'es',
        countryCode: 'MX',
        language: 'Spanish',
        country: 'Mexico',
    },
    {
        languageCode: 'ro',
        countryCode: 'MD',
        language: 'Romanian',
        country: 'Moldova',
    },
    {
        languageCode: 'ru',
        countryCode: 'MD',
        language: 'Russian',
        country: 'Moldova',
    },
    {
        languageCode: 'mn',
        countryCode: 'MN',
        language: 'Mongolian',
        country: 'Mongolia',
    },
    {
        languageCode: 'ar',
        countryCode: 'MA',
        language: 'Arabic',
        country: 'Morocco',
    },
    {
        languageCode: 'fr',
        countryCode: 'MA',
        language: 'French',
        country: 'Morocco',
    },
    {
        languageCode: 'pt',
        countryCode: 'MZ',
        language: 'Portuguese',
        country: 'Mozambique',
    },
    {
        languageCode: 'my',
        countryCode: 'MM',
        language: 'Burmese',
        country: 'Myanmar (Burma)',
    },
    {
        languageCode: 'ne',
        countryCode: 'NP',
        language: 'Nepali',
        country: 'Nepal',
    },
    {
        languageCode: 'nl',
        countryCode: 'NL',
        language: 'Dutch',
        country: 'Netherlands',
    },
    {
        languageCode: 'en',
        countryCode: 'NZ',
        language: 'English',
        country: 'New Zealand',
    },
    {
        languageCode: 'mi',
        countryCode: 'NZ',
        language: 'Maori',
        country: 'New Zealand',
    },
    {
        languageCode: 'es',
        countryCode: 'NI',
        language: 'Spanish',
        country: 'Nicaragua',
    },
    {
        languageCode: 'en',
        countryCode: 'NG',
        language: 'English',
        country: 'Nigeria',
    },
    {
        languageCode: 'yo',
        countryCode: 'NG',
        language: 'Yoruba',
        country: 'Nigeria',
    },
    {
        languageCode: 'mk',
        countryCode: 'MK',
        language: 'Macedonian',
        country: 'North Macedonia',
    },
    {
        languageCode: 'nb',
        countryCode: 'NO',
        language: 'Norwegian Bokmål',
        country: 'Norway',
    },
    {
        languageCode: 'nn',
        countryCode: 'NO',
        language: 'Norwegian Nynorsk',
        country: 'Norway',
    },
    {
        languageCode: 'ar',
        countryCode: 'OM',
        language: 'Arabic',
        country: 'Oman',
    },
    {
        languageCode: 'ps',
        countryCode: 'PK',
        language: 'Pashto',
        country: 'Pakistan',
    },
    {
        languageCode: 'pa',
        countryCode: 'PK',
        language: 'Punjabi',
        country: 'Pakistan',
    },
    {
        languageCode: 'sd',
        countryCode: 'PK',
        language: 'Sindhi',
        country: 'Pakistan',
    },
    {
        languageCode: 'ur',
        countryCode: 'PK',
        language: 'Urdu',
        country: 'Pakistan',
    },
    {
        languageCode: 'ar',
        countryCode: 'PS',
        language: 'Arabic',
        country: 'Palestinian Territories',
    },
    {
        languageCode: 'es',
        countryCode: 'PA',
        language: 'Spanish',
        country: 'Panama',
    },
    {
        languageCode: 'es',
        countryCode: 'PY',
        language: 'Spanish',
        country: 'Paraguay',
    },
    {
        languageCode: 'qu',
        countryCode: 'PE',
        language: 'Quechua',
        country: 'Peru',
    },
    {
        languageCode: 'es',
        countryCode: 'PE',
        language: 'Spanish',
        country: 'Peru',
    },
    {
        languageCode: 'fil',
        countryCode: 'PH',
        language: 'Filipino',
        country: 'Philippines',
    },
    {
        languageCode: 'pl',
        countryCode: 'PL',
        language: 'Polish',
        country: 'Poland',
    },
    {
        languageCode: 'pt',
        countryCode: 'PT',
        language: 'Portuguese',
        country: 'Portugal',
    },
    {
        languageCode: 'es',
        countryCode: 'PR',
        language: 'Spanish',
        country: 'Puerto Rico',
    },
    {
        languageCode: 'ar',
        countryCode: 'QA',
        language: 'Arabic',
        country: 'Qatar',
    },
    {
        languageCode: 'ro',
        countryCode: 'RO',
        language: 'Romanian',
        country: 'Romania',
    },
    {
        languageCode: 'ba',
        countryCode: 'RU',
        language: 'Bashkir',
        country: 'Russia',
    },
    {
        languageCode: 'ru',
        countryCode: 'RU',
        language: 'Russian',
        country: 'Russia',
    },
    {
        languageCode: 'tt',
        countryCode: 'RU',
        language: 'Tatar',
        country: 'Russia',
    },
    {
        languageCode: 'rw',
        countryCode: 'RW',
        language: 'Kinyarwanda',
        country: 'Rwanda',
    },
    {
        languageCode: 'ar',
        countryCode: 'SA',
        language: 'Arabic',
        country: 'Saudi Arabia',
    },
    {
        languageCode: 'fr',
        countryCode: 'SN',
        language: 'French',
        country: 'Senegal',
    },
    {
        languageCode: 'zh',
        countryCode: 'SG',
        language: 'Chinese',
        country: 'Singapore',
    },
    {
        languageCode: 'en',
        countryCode: 'SG',
        language: 'English',
        country: 'Singapore',
    },
    {
        languageCode: 'ta',
        countryCode: 'SG',
        language: 'Tamil',
        country: 'Singapore',
    },
    {
        languageCode: 'sk',
        countryCode: 'SK',
        language: 'Slovak',
        country: 'Slovakia',
    },
    {
        languageCode: 'sl',
        countryCode: 'SI',
        language: 'Slovenian',
        country: 'Slovenia',
    },
    {
        languageCode: 'so',
        countryCode: 'SO',
        language: 'Somali',
        country: 'Somalia',
    },
    {
        languageCode: 'af',
        countryCode: 'ZA',
        language: 'Afrikaans',
        country: 'South Africa',
    },
    {
        languageCode: 'en',
        countryCode: 'ZA',
        language: 'English',
        country: 'South Africa',
    },
    {
        languageCode: 'nso',
        countryCode: 'ZA',
        language: 'Northern Sotho',
        country: 'South Africa',
    },
    {
        languageCode: 'ts',
        countryCode: 'ZA',
        language: 'Tsonga',
        country: 'South Africa',
    },
    {
        languageCode: 'tn',
        countryCode: 'ZA',
        language: 'Tswana',
        country: 'South Africa',
    },
    {
        languageCode: 'xh',
        countryCode: 'ZA',
        language: 'Xhosa',
        country: 'South Africa',
    },
    {
        languageCode: 'zu',
        countryCode: 'ZA',
        language: 'Zulu',
        country: 'South Africa',
    },
    {
        languageCode: 'ko',
        countryCode: 'KR',
        language: 'Korean',
        country: 'South Korea',
    },
    {
        languageCode: 'ast',
        countryCode: 'ES',
        language: 'Asturian',
        country: 'Spain',
    },
    {
        languageCode: 'eu',
        countryCode: 'ES',
        language: 'Basque',
        country: 'Spain',
    },
    {
        languageCode: 'ca',
        countryCode: 'ES',
        language: 'Catalan',
        country: 'Spain',
    },
    {
        languageCode: 'gl',
        countryCode: 'ES',
        language: 'Galician',
        country: 'Spain',
    },
    {
        languageCode: 'es',
        countryCode: 'ES',
        language: 'Spanish',
        country: 'Spain',
    },
    {
        languageCode: 'si',
        countryCode: 'LK',
        language: 'Sinhala',
        country: 'Sri Lanka',
    },
    {
        languageCode: 'ta',
        countryCode: 'LK',
        language: 'Tamil',
        country: 'Sri Lanka',
    },
    {
        languageCode: 'ar',
        countryCode: 'SD',
        language: 'Arabic',
        country: 'Sudan',
    },
    {
        languageCode: 'sv',
        countryCode: 'SE',
        language: 'Swedish',
        country: 'Sweden',
    },
    {
        languageCode: 'fr',
        countryCode: 'CH',
        language: 'French',
        country: 'Switzerland',
    },
    {
        languageCode: 'de',
        countryCode: 'CH',
        language: 'German',
        country: 'Switzerland',
    },
    {
        languageCode: 'it',
        countryCode: 'CH',
        language: 'Italian',
        country: 'Switzerland',
    },
    {
        languageCode: 'ar',
        countryCode: 'SY',
        language: 'Arabic',
        country: 'Syria',
    },
    {
        languageCode: 'zh',
        countryCode: 'TW',
        language: 'Chinese',
        country: 'Taiwan',
    },
    {
        languageCode: 'tg',
        countryCode: 'TJ',
        language: 'Tajik',
        country: 'Tajikistan',
    },
    {
        languageCode: 'sw',
        countryCode: 'TZ',
        language: 'Swahili',
        country: 'Tanzania',
    },
    {
        languageCode: 'th',
        countryCode: 'TH',
        language: 'Thai',
        country: 'Thailand',
    },
    {
        languageCode: 'ar',
        countryCode: 'TN',
        language: 'Arabic',
        country: 'Tunisia',
    },
    {
        languageCode: 'fr',
        countryCode: 'TN',
        language: 'French',
        country: 'Tunisia',
    },
    {
        languageCode: 'ku',
        countryCode: 'TR',
        language: 'Kurdish',
        country: 'Turkey',
    },
    {
        languageCode: 'tr',
        countryCode: 'TR',
        language: 'Turkish',
        country: 'Turkey',
    },
    {
        languageCode: 'tk',
        countryCode: 'TM',
        language: 'Turkmen',
        country: 'Turkmenistan',
    },
    {
        languageCode: 'sw',
        countryCode: 'UG',
        language: 'Swahili',
        country: 'Uganda',
    },
    {
        languageCode: 'uk',
        countryCode: 'UA',
        language: 'Ukrainian',
        country: 'Ukraine',
    },
    {
        languageCode: 'ar',
        countryCode: 'AE',
        language: 'Arabic',
        country: 'United Arab Emirates',
    },
    {
        languageCode: 'en',
        countryCode: 'GB',
        language: 'English',
        country: 'United Kingdom',
    },
    {
        languageCode: 'gd',
        countryCode: 'GB',
        language: 'Scottish Gaelic',
        country: 'United Kingdom',
    },
    {
        languageCode: 'cy',
        countryCode: 'GB',
        language: 'Welsh',
        country: 'United Kingdom',
    },
    {
        languageCode: 'en',
        countryCode: 'US',
        language: 'English',
        country: 'United States',
    },
    {
        languageCode: 'es',
        countryCode: 'US',
        language: 'Spanish',
        country: 'United States',
    },
    {
        languageCode: 'es',
        countryCode: 'UY',
        language: 'Spanish',
        country: 'Uruguay',
    },
    {
        languageCode: 'es',
        countryCode: 'VE',
        language: 'Spanish',
        country: 'Venezuela',
    },
    {
        languageCode: 'vi',
        countryCode: 'VN',
        language: 'Vietnamese',
        country: 'Vietnam',
    },
    {
        languageCode: 'ar',
        countryCode: 'EH',
        language: 'Arabic',
        country: 'Western Sahara',
    },
    {
        languageCode: 'ar',
        countryCode: 'YE',
        language: 'Arabic',
        country: 'Yemen',
    },
    {
        languageCode: 'nd',
        countryCode: 'ZW',
        language: 'North Ndebele',
        country: 'Zimbabwe',
    },
    {
        languageCode: 'am',
        countryCode: 'ER',
        language: 'Amharic',
        country: 'Eritrea',
    },
    {
        languageCode: 'ar',
        countryCode: 'AA',
        language: 'Arabic',
        country: 'World',
    },
    {
        languageCode: 'az',
        countryCode: 'AZ',
        script: 'Cyrl',
        language: 'Azeri (Cyrillic)',
        country: 'Azerbaijan',
    },
    {
        languageCode: 'az',
        countryCode: 'AZ',
        script: 'Latn',
        language: 'Azeri (Latin)',
        country: 'Azerbaijan',
    },
    {
        languageCode: 'bam',
        countryCode: '',
        language: 'Bambara',
        country: 'Mali',
    },
    {
        languageCode: 'bal',
        countryCode: 'IR',
        language: 'Bhutani',
        country: 'Bhutan',
    },
    {
        languageCode: 'bh',
        countryCode: 'IN',
        language: 'Bihari',
        country: 'India',
    },
    {
        languageCode: 'bi',
        countryCode: 'VU',
        language: 'Bislama',
        country: 'Vanuatu',
    },
    {
        languageCode: 'bs',
        countryCode: 'BA',
        script: 'Cyrl',
        language: 'Bosnian (Cyrillic)',
        country: 'Bosnia & Herzegovina',
    },
    {
        languageCode: 'bs',
        countryCode: 'BA',
        script: 'Latn',
        language: 'Bosnian (Latin)',
        country: 'Bosnia & Herzegovina',
    },
    {
        languageCode: 'bsk',
        countryCode: '',
        language: 'Burushaski',
        country: 'Pakistan',
    },
    {
        languageCode: 'cal',
        countryCode: '',
        language: 'Carolinian',
        country: 'Northern Mariana Islands',
    },
    {
        languageCode: 'ceb',
        countryCode: '',
        language: 'Cebuano',
        country: 'Philippines',
    },
    {
        languageCode: 'cjm',
        countryCode: '',
        language: 'Cham (Eastern)',
        country: 'Cambodia',
    },
    {
        languageCode: 'cja',
        countryCode: '',
        language: 'Cham (Western)',
        country: 'Cambodia',
    },
    {
        languageCode: 'cha',
        countryCode: '',
        language: 'Chamorro',
        country: 'Guam',
    },
    {
        languageCode: 'ts',
        countryCode: 'ZA',
        script: 'changana',
        language: 'Changana',
        country: 'South Africa',
    },
    {
        languageCode: 'chr',
        countryCode: '',
        language: 'Cherokee',
        country: 'United States',
    },
    {
        languageCode: 'zh',
        countryCode: 'YUE',
        language: 'Chinese (Cantonese)',
        country: 'Hong Kong',
    },
    {
        languageCode: 'goyu',
        countryCode: '',
        language: 'Chinese (Mandarin Traditional)',
        country: 'Taiwan',
    },
    {
        languageCode: 'cmn',
        countryCode: '',
        language: 'Chinese (Mandarin Traditional)',
        country: 'World',
    },
    {
        languageCode: 'zh',
        countryCode: 'HK',
        script: 'Hans',
        language: 'Chinese (Simplified, HK)',
        country: 'Hong Kong',
    },
    {
        languageCode: 'hy',
        countryCode: 'AM',
        script: 'arevela',
        language: 'Eastern Armenian',
        country: 'Armenia',
    },
    {
        languageCode: 'en',
        countryCode: '142',
        language: 'English',
        country: 'Asia',
    },
    {
        languageCode: 'en',
        countryCode: 'NT',
        language: 'English',
        country: 'Neutral',
    },
    {
        languageCode: 'eo',
        countryCode: '',
        language: 'Esperanto',
        country: 'World',
    },
    {
        languageCode: 'fj',
        countryCode: 'FJ',
        language: 'Fijian',
        country: 'Fiji',
    },
    {
        languageCode: 'grc',
        countryCode: 'GR',
        language: 'Greek (Ancient)',
        country: 'Greece',
    },
    {
        languageCode: 'grn',
        countryCode: '',
        language: 'Guarani',
        country: 'Paraguay',
    },
    {
        languageCode: 'ht',
        countryCode: 'HT',
        language: 'Haitian Creole',
        country: 'Haïti',
    },
    {
        languageCode: 'haw',
        countryCode: '',
        language: 'Hawaiian',
        country: 'United States',
    },
    {
        languageCode: 'xz',
        countryCode: 'AF',
        language: 'Hazaragi',
        country: 'Afganistan',
    },
    {
        languageCode: 'hil',
        countryCode: '',
        language: 'Hiligaynon',
        country: 'Philippines',
    },
    {
        languageCode: 'kgp',
        countryCode: 'BR',
        language: 'Kaingang',
        country: 'Brazil',
    },
    {
        languageCode: 'ks',
        countryCode: '',
        language: 'Kashmiri',
        country: 'India',
    },
    {
        languageCode: 'kg',
        countryCode: 'CG',
        language: 'Kikongo',
        country: 'Kongo',
    },
    {
        languageCode: 'ky',
        countryCode: '',
        language: 'Kirghiz',
        country: 'Kyrghyzstan',
    },
    {
        languageCode: 'kun',
        countryCode: '',
        language: 'Kunama',
        country: 'Western Eritrea',
    },
    {
        languageCode: 'ku',
        countryCode: 'IQ',
        language: 'Kurdish',
        country: 'Iraq',
    },
    {
        languageCode: 'kmr',
        countryCode: '',
        language: 'Kurdish',
        country: 'Kurmanji',
    },
    {
        languageCode: 'ckb',
        countryCode: '',
        language: 'Kurdish',
        country: 'Sorani',
    },
    {
        languageCode: 'la',
        countryCode: '',
        language: 'Latin',
        country: 'World',
    },
    {
        languageCode: 'ms',
        countryCode: 'AR',
        language: 'Malay',
        country: 'Jawi',
    },
    {
        languageCode: 'ms',
        countryCode: 'SG',
        language: 'Malay',
        country: 'Singapore',
    },
    {
        languageCode: 'mo',
        countryCode: 'MD',
        language: 'Moldavian',
        country: 'Moldavia',
    },
    {
        languageCode: 'sla',
        countryCode: 'ME',
        language: 'Montenegrin',
        country: 'Montenegro',
    },
    {
        languageCode: 'na',
        countryCode: 'NR',
        language: 'Nauru',
        country: 'Micronesia',
    },
    {
        languageCode: 'nv',
        countryCode: '',
        language: 'Navajo',
        country: 'United States',
    },
    {
        languageCode: 'no',
        countryCode: 'NO',
        language: 'Norwegian',
        country: 'Norway',
    },
    {
        languageCode: 'ota',
        countryCode: '',
        language: 'Ottoman Turkish',
        country: 'Turkey',
    },
    {
        languageCode: 'qya',
        countryCode: '',
        language: 'Quenya',
        country: 'Middle Earth',
    },
    {
        languageCode: 'xr',
        countryCode: 'MM',
        language: 'Rohingya (Myanmar)',
        country: 'Myanmar',
    },
    {
        languageCode: 'ru',
        countryCode: 'AM',
        language: 'Russian',
        country: 'Armenian',
    },
    {
        languageCode: 'ru',
        countryCode: 'AZ',
        language: 'Russian',
        country: 'Azerbaijan',
    },
    {
        languageCode: 'ru',
        countryCode: 'GE',
        language: 'Russian',
        country: 'Georgia',
    },
    {
        languageCode: 'sm',
        countryCode: 'WS',
        language: 'Samoan',
        country: 'Samoa',
    },
    {
        languageCode: 'sco',
        countryCode: 'IE',
        language: 'Scots',
        country: 'Ireland',
    },
    {
        languageCode: 'sco',
        countryCode: 'GB',
        language: 'Scots',
        country: 'United Kingdom',
    },
    {
        languageCode: 'sr',
        countryCode: 'YU',
        language: 'Serbian',
        country: 'Serbia',
    },
    {
        languageCode: 'sr',
        countryCode: 'ME',
        script: 'Latn',
        language: 'Serbian (Latin)',
        country: 'Montenegro',
    },
    {
        languageCode: 'sr',
        countryCode: 'RS',
        script: 'Cyrl',
        language: 'Serbian (Cyrillic)',
        country: 'Serbia',
    },
    {
        languageCode: 'sr',
        countryCode: 'ME',
        script: 'Cyrl',
        language: 'Serbian (Cyrillic)',
        country: 'Montenegro',
    },
    {
        languageCode: 'sr',
        countryCode: 'RS',
        script: 'Latn',
        language: 'Serbian (Latin)',
        country: 'Serbia',
    },
    {
        languageCode: 'es',
        countryCode: 'NT',
        language: 'Spanish (Neutral)',
        country: 'World',
    },
    {
        languageCode: 'sw',
        countryCode: 'SO',
        language: 'Swahili',
        country: 'Somalia',
    },
    {
        languageCode: 'swa',
        countryCode: '',
        language: 'Swahili',
        country: 'World',
    },
    {
        languageCode: 'tl',
        countryCode: 'PH',
        language: 'Tagalog',
        country: 'Philippines',
    },
    {
        languageCode: 'ty',
        countryCode: '',
        language: 'Tahitian',
        country: 'Tahiti',
    },
    {
        languageCode: 'tet',
        countryCode: 'ID',
        language: 'Tetum',
        country: 'Indonesia',
    },
    {
        languageCode: 'tet',
        countryCode: 'TL',
        language: 'Tetum',
        country: 'Timor-Leste',
    },
    {
        languageCode: 'bo',
        countryCode: '',
        language: 'Tibetan',
        country: 'Tibet',
    },
    {
        languageCode: 'ton',
        countryCode: '',
        language: 'Tongan',
        country: 'Tonga',
    },
    {
        languageCode: 'uz',
        countryCode: 'UZ',
        script: 'Cyrl',
        language: 'Uzbek (Cyrillic)',
        country: 'Uzbekistan',
    },
    {
        languageCode: 'uz',
        countryCode: 'UZ',
        script: 'Latn',
        language: 'Uzbek (Latin)',
        country: 'Uzbekistan',
    },
    {
        languageCode: 'war',
        countryCode: '',
        language: 'Waray',
        country: 'Philippines',
    },
    {
        languageCode: 'hy',
        countryCode: 'AM',
        script: 'arevmda',
        language: 'Western Armenian',
        country: 'Armenia',
    },
    {
        languageCode: 'yi',
        countryCode: 'IL',
        language: 'Yiddish',
        country: 'Israel',
    },
    {
        languageCode: 'yi',
        countryCode: 'US',
        language: 'Yiddish',
        country: 'USA',
    },
];
